<template>
  <div class="content" style="min-height: 100vh">
    <div
      class="background-image-search"
      style="background-image: url(/img/temp/blurred-dark.jpg"
    ></div>
    <!-- /.background-image-search -->

    <base-header class="header--recipe pb-6" type="none">
      <b-row align-v="center" class="py-4">
        <h1>Add New Unit</h1>
      </b-row>
    </base-header>
    <b-container
      class="container--md mt--6"
    >
      <div class="add-recipe__container">
        <validation-observer v-slot="{handleSubmit}" ref="formValidator">
      <form class="needs-validation"
            @submit.prevent="handleSubmit(firstFormSubmit)">
        <div class="form-row">
          <b-col md="4">
            <base-input label="Unit Full Name"
                        name="longName"
                        type="textarea"
                        placeholder="Cup"
                        rules="required"
                        v-model="model.longName">
            </base-input>
          </b-col>
          <b-col md="4">
            <base-input label="Unit Abbreviation"
                        name="name"
                        type="textarea"
                        placeholder="C (optional"
                        v-model="model.name">
            </base-input>
          </b-col>
          <b-col md="4">
            <base-input label="Unit Plural Name"
                        name="pluralName"
                        type="textarea"
                        placeholder="Cups"
                        rules="required"
                        v-model="model.pluralName">
            </base-input>
          </b-col>
          <b-col md="2">
            <label class="form-control-label">
              Show When Zero?
            </label><br />
            <base-switch label="Show When Zero?"
                    name="showWhenZero"
                    class="mr-1" 
                    on-text="Yes" 
                    off-text="No" 
                    v-model="model.showWhenZero">
            </base-switch>
          </b-col>
          <b-col md="2">
            <label class="form-control-label">
              Active?
            </label><br />
            <base-switch label="Is Active?"
                    name="isActive"
                    class="mr-1" 
                    on-text="Yes" 
                    off-text="No" 
                    v-model="model.isActive">
            </base-switch>
          </b-col>
        </div>
        <base-button type="primary" @click="addSubmit('/units')">Save and Close</base-button>
        <base-button type="primary" @click="addSubmit('/unit/add-unit')">Save and Add Another</base-button>
      </form>
    </validation-observer>
      </div>
    </b-container>
  </div>
</template>
<script>
  import { Select, Option } from 'element-ui'
  import uuid from 'uuid';

  export default {
    name: "AddTag",
    components: {
        [Select.name]: Select,
        [Option.name]: Option
    },
    data() {
      return {
        validated: false,
        model: {
          id: '',
          name: '',
          longName: '',
          pluralName: '',
          showWhenZero: true,
          isActive: true,
          isDeleted: false
        }
      }
    },
    methods: {
      addSubmit(goTo) {
        this.model.id = uuid();
        const { dispatch } = this.$store;
        this.model.id = uuid();

        this.model.name = (this.model.name=='') ? this.model.longName : this.model.name

        if (this.model.name) {
          try {
              dispatch("units/addUnit", this.model)
                  .then(response => {
                  this.$notify({verticalAlign: 'top', horizontalAlign: 'right', type: 'success', message: 'Unit Added'});
                  const { dispatch } = this.$store;
                  dispatch("units/getAllUnits");
                  this.$router.push({path: goTo});
                  this.resetForm();
              }).catch(error => {
                  console.log('Something went wrong: ', error);
              });
          } catch (error) {
              console.log("Error: tag add", error);
          }
        }
      },
      resetForm() {
        this.model.id = '';
        this.model.name = '';
        this.model.longName = '';
        this.model.pluralName = '';
      }
    }
  }
</script>
<style>
.shortcut-item.add-collection{
  text-align: left;
  margin-bottom: 30px;
}
</style>
